import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Helmet } from 'react-helmet'

const TenantMetadata = () => {
  const tenant = useSelector((state) => state?.globals?.tenant)

  useEffect(() => {
    if (!tenant) return

    // Update favicon
    const favicon = document.querySelector('link[rel="icon"]')
    if (favicon) {
      favicon.href = tenant.deployment_logo_smallt || ''
    }

    // Update apple touch icon
    const appleTouchIcon = document.querySelector(
      'link[rel="apple-touch-icon"]'
    )
    if (appleTouchIcon) {
      appleTouchIcon.href = tenant.deployment_logo_small || ''
    }

    // Set root font size
    document.documentElement.style.fontSize = '14px'

    // Update Balance Checkout styles if needed
    const balanceCheckoutStyle = document.querySelector(
      '#balance-checkout-style'
    )
    if (!balanceCheckoutStyle) {
      const style = document.createElement('style')
      style.id = 'balance-checkout-style'
      style.innerHTML = `
        #balance-checkout > div {
          position: fixed;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
        }
      `
      document.head.appendChild(style)
    }
  }, [tenant])

  if (!tenant) return null

  return (
    <Helmet>
      <title>{tenant.deployment_name}</title>
      <meta property="og:title" content={tenant.deployment_name} />
      <meta property="og:image" content={tenant.deployment_logo_small} />
      <meta property="og:image:type" content="image/png" />
      <meta name="description" content={tenant.deployment_name} />

      {/* Load tenant-specific scripts */}
      {/* {tenant.balanceUrl && <script src={tenant.balanceUrl} />} */}
    </Helmet>
  )
}

export default TenantMetadata
